import styled from 'styled-components';
import { setColor, setRem } from '../../../helpers/styleUtils';
export const Logo = styled.h1`
  color: ${setColor.fontDark};
`;
export const SmallLogo = styled.h3`
  color: ${setColor.mainWhite};
  padding-top: ${setRem(10)};
`;